import { render, staticRenderFns } from "./SellerAccountApprovedOffers.vue?vue&type=template&id=428f6668"
import script from "./SellerAccountApprovedOffers.vue?vue&type=script&lang=js"
export * from "./SellerAccountApprovedOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports